function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMakeCorrectionsi = function SvgMakeCorrectionsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M16.257 8.009a.734.734 0 0 0-1.04 0l-6.685 6.685a.74.74 0 0 0-.212.44l-.28 2.531a.738.738 0 0 0 .788.814l2.414-.186a.74.74 0 0 0 .464-.213l6.79-6.791a.734.734 0 0 0 0-1.04zm-10.741 9H3.719a.736.736 0 0 0 0 1.471h1.797a.736.736 0 0 0 0-1.47m4.238-1.457L9.6 16.944l1.258-.097 6.079-6.079-1.2-1.2zm-1.678-4.287H3.719a.736.736 0 0 0 0 1.47h4.357a.735.735 0 1 0 0-1.47m8.747-4.883a.736.736 0 0 0 0 1.04l2.262 2.256a.736.736 0 0 0 1.04 0l.644-.645a.736.736 0 0 0 0-1.04L18.51 5.735a.734.734 0 0 0-1.04 0zm-3-.862H3.72a.736.736 0 0 0 0 1.47h10.104a.736.736 0 0 0 0-1.47"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMakeCorrectionsi);
export default ForwardRef;